import { useState, useEffect } from 'react'

interface LogoPreviewProps {
  logo: File | null
  fallbackUrl?: string
}

export function LogoPreview({ logo, fallbackUrl }: LogoPreviewProps) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)

  useEffect(() => {
    let revokeUrl: string | null = null
    if (logo && logo instanceof File && logo.size > 0) {
      try {
        const url = URL.createObjectURL(logo)
        revokeUrl = url
        setPreviewUrl(url)
      } catch (error) {
        setPreviewUrl(null)
      }
    } else if (logo && typeof (logo as any)?.serverUrl === 'string') {
      setPreviewUrl((logo as any).serverUrl)
    } else if (fallbackUrl) {
      setPreviewUrl(fallbackUrl)
    } else {
      setPreviewUrl(null)
    }

    return () => {
      if (revokeUrl) {
        try {
          URL.revokeObjectURL(revokeUrl)
        } catch (error) {
          // noop
        }
      }
    }
  }, [logo, fallbackUrl])

  if (!previewUrl) {
    return (
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 bg-neutral-100 rounded-lg flex items-center justify-center">
            <span className="text-xs text-neutral-400">64px</span>
          </div>
          <div className="w-9 h-9 bg-neutral-100 rounded flex items-center justify-center">
            <span className="text-xs text-neutral-400">36px</span>
          </div>
          <div className="w-7 h-7 bg-neutral-100 rounded flex items-center justify-center">
            <span className="text-xs text-neutral-400">28px</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <div className="relative w-16 h-16 bg-neutral-100 rounded-lg overflow-hidden">
          <img
            src={previewUrl || '/placeholder.svg'}
            alt="Logo preview 64px"
            className="object-contain w-full h-full"
          />
        </div>
        <div className="relative w-9 h-9 bg-neutral-100 rounded overflow-hidden">
          <img
            src={previewUrl || '/placeholder.svg'}
            alt="Logo preview 36px"
            className="object-contain w-full h-full"
          />
        </div>
        <div className="relative w-7 h-7 bg-neutral-100 rounded overflow-hidden">
          <img
            src={previewUrl || '/placeholder.svg'}
            alt="Logo preview 28px"
            className="object-contain w-full h-full"
          />
        </div>
      </div>
      <p className="text-neutral-400 text-xs">Preview at different sizes</p>
    </div>
  )
}
